import { useQuery } from '@tanstack/react-query'
import {
	message,
	Input,
	Select,
	Table,
	Button,
	Modal,
	Checkbox,
	AutoComplete,
	Space,
	Tag,
	InputNumber,
	Spin,
	Radio,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { get } from 'lodash'
import moment from 'moment'
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import CopyIcon from '@assets/icons/CopySvg'
import ViewIcon from '@assets/icons/viewSvg.jsx'
import Layout from '@components/Layout'
import ConfirmExitModal from '@components/Modal/ConfirmExitModal/index'
import CreteCustomerModal from '@components/Modal/createCustomerModal'
import ErrorModal from '@components/Modal/ErrorModal'
import SuccessModal from '@components/Modal/SuccessModal'
import ViewDepartmentsBalanceModal from '@components/Modal/viewDepartmentsBalanceModal'
import WarningModal from '@components/Modal/WarningModal/index'
import { http } from '@services/http'
import { submitSalesOrder } from '@slice/salesSlice'
import { calculateKvmWithSpaces , calculateKvm } from '@utils/calculateKvm'
import {
	calculateTotalWithKoef,
	calculateLineTotal,
	calculateMetrTotalWithKoef,
} from '@utils/calculations'
import { debouncedSet } from '@utils/debounce'
import { catchError } from '@utils/errrorHandling'
import {
	fetchClientsSelect,
	fetchDepartments,
	fetchSalesPerson,
	fetchWarehouse,
	fetchPackageServicesNoPagination,
} from '@utils/fetchData'
import { generateImage } from '@utils/generateShapeImage'
import {
	formatNumberWithSpaces,
	numberWithSpacesIntl,
	removeSpaces,
} from '@utils/numberWithSpaces'
import renderServiceTypeSvg from '@utils/renderServiceTypeSvg'
import {
	calculateShtPrices,
	calculateMetrPriceServices,
	calculateMetrPriceParametr,
	calculateKvmPrices,
	circleServiceQuantity,
	circleShapeQuantity,
	semiCircleShapeQuantity,
	shapeSidesQuantity,
	perimeterQuantity,
} from '@utils/salesOrderCalculations'

// This is the hardest screen in our project and I know that i have to optimize my codes in this page when i will be free i will do it

const CreateSales = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const successRef = useRef()
	const errorRef = useRef()
	const warningRef = useRef()


	const { roleNames, getMe, slpCode, department } = useSelector(
		(state) => state.main,
	)

	const isAdmin = roleNames.includes('admin')

	const [defaultService, setDefaultService] = useState({})

	const [clientCode, setClientCode] = useState('')
	const [clientName, setClientName] = useState('')
	const [searchClientName, setSearchClientName] = useState('')
	const [searchItemName, setSearchItemName] = useState('')
	const [date, setDate] = useState('')
	const [currency, setCurrency] = useState('UZS')
	const [comments, setComments] = useState('')
	const [sendFile, setSendFile] = useState(false)
	const [imageList, setImageList] = useState([
		{ file: null, path: '', imgLoading: false },
	])
	const [whs, setWhs] = useState(get(getMe, 'u_WareHouse', ''))
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false)
	const [isViewBpBalanceModalVisible, setIsViewBpBalanceModalVisible] =
		useState(false)
	const [isConfirmServiceModalVisible, setIsConfirmServiceModalVisible] =
		useState(false)
	const [activeTab, setActiveTab] = useState('tab1')
	const [btnLoading, setIsBtnLoading] = useState(false)
	const [isDiscountBigger, setIsDiscountBigger] = useState(false)
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [selectedServices, setSelectedServices] = useState([])
	const [currentRecord, setCurrentRecord] = useState(null)
	const [departmentAdmin, setDepartmentAdmin] = useState(department)
	const [slpAdmin, setSlpAdmin] = useState(get(getMe, 'salesPersonCode', ''))
	const [dateSale, setDateSale] = useState(moment().format('YYYY-MM-DD'))
	const [bpDebt, setBpDebt] = useState('')
	const [docTotalWithDiscount, setDocTotalWithDiscount] = useState(0)
	const [inputDocTotal, setInputDocTotal] = useState(0)
	const [inputValues, setInputValues] = useState({})
	const [inputParametrQuantity, setInputParametrQuantity] = useState({})
	const [tableData, setTableData] = useState([
		{
			key: '1',
			itemCode: null,
			itemName: null,
			width: '',
			height: '',
			quantity: '',
			ugpName: '',
			price: '',
			currency: currency,
			lineTotal: '',
			lineNum: 0,
			u_Timer: '',
			disabled: false,
			koefitsent: 1,
			selectedServices: [],
			amountInWhs: 0,
			itemType: 'Item',
		},
	])
	const [expensesItems, setExpensesItems] = useState([])

	const [inputDateCount, setInputDateCount] = useState('')

	const docTotal = tableData.reduce((acc, row) => {
		const koef = row.koefitsent || 1

		const selectedPrices = row?.selectedServices?.reduce((acc, service) => {
			if (
				service.ugpName !== 'шт' &&
				service.ugpName !== 'м' &&
				service.u_Modal !== 'Templete_Services' &&
				service.u_Modal !== 'ort'
			) {
				return (
					acc +
					service.price *
						(calculateKvm(row?.width, row?.height) * row?.quantity)
				)
			}
			return acc
		}, 0)

		const shtPrices = calculateShtPrices(row?.selectedServices)

		const metrPricesServices = calculateMetrPriceServices(
			row?.selectedServices,
		)

		const metrPricesParametr = calculateMetrPriceParametr(
			row?.selectedServices,
		)

		const totalWithKoef = calculateTotalWithKoef(
			row.width,
			row.height,
			row.quantity,
			koef,
		)

		return (
			acc +
			(calculateLineTotal(row.price, 0, totalWithKoef || 0) +
				(shtPrices || 0) +
				(selectedPrices || 0) +
				(metrPricesServices || 0) +
				(metrPricesParametr || 0))
		)
	}, 0)

	const totalKvm = new Intl.NumberFormat().format(
		tableData.reduce(
			(acc, row) =>
				acc +
				parseFloat(row.quantity * calculateKvm(row.width, row.height)),
			0,
		),
	)

	const totalPerimetr = new Intl.NumberFormat().format(
		tableData.reduce((acc, row) => acc + row.totalPerimetr || 0, 0),
	)

	const sanitizeDocTotalValue = (rawValue) => {
		const sanitizedValue = rawValue
			.replace(/\s+/g, '')
			.replace(',', '.')

		return parseFloat(sanitizedValue) || 0
	}

	const handleDocTotalChange = (e) => {
		const value = sanitizeDocTotalValue(e.target.value)
		const originalDocTotal = Number(docTotal) || 0

		// if (!isAdmin && value < originalDocTotal) {
		// 	setInputDocTotal(originalDocTotal)
		// 	setIsDiscountBigger(false)
		// 	return
		// }

		setInputDocTotal(value)
if(!isAdmin) {
			setIsDiscountBigger(value < originalDocTotal)
}
	}

	const handleDocTotalBlur = (e) => {
		const value = sanitizeDocTotalValue(e.target.value)
		const originalDocTotal = Number(docTotal) || 0
		if(!value) {
			setInputDocTotal(originalDocTotal)
return
		}

		if (!isAdmin && value < originalDocTotal) {
			setInputDocTotal(originalDocTotal)
			setIsDiscountBigger(true)
			return
		}

		setInputDocTotal(value)
if(!isAdmin ) {
			setIsDiscountBigger(value < originalDocTotal)
}
	}

	const arendaTotal = tableData?.reduce(
		(acc, row) => {
			const arendaItem = expensesItems?.find(
				(item) => item.itemCode?.toLowerCase() === 'arenda',
			)
			const koef = row.koefitsent || 1
			const totalWithKoef = calculateTotalWithKoef(
				row.width,
				row.height,
				row.quantity,
				1,
			)

			return {
				total: acc.total + totalWithKoef * (arendaItem?.price || 0),
				itemCode: arendaItem?.itemCode,
			}
		},
		{ total: 0, itemCode: '' },
	)

	const ishHaqiTotal = tableData?.reduce(
		(acc, row) => {
			const Ish_xaqqi = expensesItems?.find(
				(item) => item.itemCode?.toLowerCase() === 'ish_xaqqi',
			)
			const koef = row.koefitsent || 1
			const totalWithKoef = calculateTotalWithKoef(
				row.width,
				row.height,
				row.quantity,
				1,
			)
			return {
				total: acc.total + totalWithKoef * (Ish_xaqqi?.price || 0),
				itemCode: Ish_xaqqi?.itemCode,
			}
		},
		{ total: 0, itemCode: '' },
	)

	const elektrTotal = tableData?.reduce(
		(acc, row) => {
			const elektrItem = expensesItems?.find(
				(item) => item.itemCode?.toLowerCase() === 'elektr_xarajat',
			)

			console.log('selectedServices', row.selectedServices)

			const koef = row.koefitsent || 1

			const selectedPrices = row?.selectedServices?.reduce(
				(acc, service) => {
					if (
						service.ugpName !== 'шт' &&
						service.ugpName !== 'м' &&
						service.u_Modal !== 'Templete_Services' &&
						service.u_Modal !== 'ort'
					) {
						return (
							acc +
							service.U_Elektr_rasxod *
								(calculateKvm(row?.width, row?.height) *
									row?.quantity)
						)
					}
					return acc
				},
				0,
			)

			const shtPrices = calculateShtPrices(
				row?.selectedServices,
				'U_Elektr_rasxod',
			)

			const metrPricesServices = calculateMetrPriceServices(
				row?.selectedServices,
				'U_Elektr_rasxod',
			)

			const metrPricesParametr = calculateMetrPriceParametr(
				row?.selectedServices,
				'U_Elektr_rasxod',
			)

			const lineTotal =
				(shtPrices || 0) +
				(selectedPrices || 0) +
				(metrPricesServices || 0) +
				(metrPricesParametr || 0)

			return {
				total: acc.total + lineTotal,
				itemCode: elektrItem?.itemCode,
			}
		},
		{ total: 0, itemCode: '' },
	)

	const stanokTotal = tableData?.reduce(
		(acc, row) => {
			const elektrItem = expensesItems?.find(
				(item) => item.itemCode?.toLowerCase() === 'stanokk_xarajat',
			)

			const koef = row.koefitsent || 1

			const selectedPrices = row?.selectedServices?.reduce(
				(acc, service) => {
					if (
						service.ugpName !== 'шт' &&
						service.ugpName !== 'м' &&
						service.u_Modal !== 'Templete_Services' &&
						service.u_Modal !== 'ort'
					) {
						return (
							acc +
							service.U_Stanok_rasxod *
								(calculateKvm(row?.width, row?.height) *
									row?.quantity)
						)
					}
					return acc
				},
				0,
			)

			const shtPrices = calculateShtPrices(
				row?.selectedServices,
				'U_Stanok_rasxod',
			)

			const metrPricesServices = calculateMetrPriceServices(
				row?.selectedServices,
				'U_Stanok_rasxod',
			)

			const metrPricesParametr = calculateMetrPriceParametr(
				row?.selectedServices,
				'U_Stanok_rasxod',
			)

			const lineTotal =
				(shtPrices || 0) +
				(selectedPrices || 0) +
				(metrPricesServices || 0) +
				(metrPricesParametr || 0)

			return {
				total: acc.total + lineTotal,
				itemCode: elektrItem?.itemCode,
			}
		},
		{ total: 0, itemCode: '' },
	)

	const fetchItemsSelect = async ({ queryKey }) => {
		const [_, itemName, category, api] = queryKey
		try {
			const url = `${api}?itemName=${itemName}&category=${category}&pageToken=0&pageSize=10000`
			const { data } = await http.get(url)

			const formattedData = data.data.map((item) => ({
				...item,
				image: generateImage(item.itemCode),
			}))
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchExpensesItems = async ({ queryKey }) => {
		const [_, uModal] = queryKey
		try {
			const url = `api/items/get-items?modalService=${uModal}&pageToken=0&pageSize=100`
			const { data } = await http.get(url)

			const formattedData = data.data
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchRombikItems = async () => {
		try {
			const url = `api/items/items-and-price-of-shapes?TabType=Rombik&PageSize=1000&Skip=0&ModalService=Rhombic_Figures`
			const { data } = await http.get(url)

			const formattedData = data.map((item) => ({
				...item,
				image: generateImage(item.itemCode),
			}))
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}
	const fetchTelefonItems = async () => {
		try {
			const url = `api/items/items-and-price-of-shapes?PageSize=1000&Skip=0&ModalService=Telefon`
			const { data } = await http.get(url)

			const formattedData = data.map((item) => ({
				...item,
				image: generateImage(item.itemCode),
			}))
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchKalitShapes = async () => {
		try {
			const url = `api/items/items-and-price-of-shapes?TabType=Kalit&PageSize=1000&Skip=0&ModalService=Key_Figures`
			const { data } = await http.get(url)

			const formattedData = data.map((item) => ({
				...item,
				image: generateImage(item.itemCode),
			}))
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchBpBalance = async ({ queryKey }) => {
		const [, clientCode] = queryKey
		if (clientCode) {
			try {
				const url = `api/businesspartners/get-business-partners-balance?cardCode=${clientCode}`
				const { data } = await http.get(url)
				setBpDebt(
					data[0]?.departments?.reduce(
						(acc, item) => acc + item.balance,
						0,
					),
				) || 0
				return data
			} catch (error) {
				console.log(error)
			}
		}
	}

	const fetchItemsInWhs = async (itemCode, index) => {
		if (itemCode) {
			try {
				const url = `api/items/inventory-items?itemCode=${itemCode}`
				const { data } = await http.get(url)
				const newTableData = [...tableData]
				newTableData[index].amountInWhs = data.data[0]?.amountInWhs || 0
				setTableData(newTableData)
				// console.log('tableDataAfterOnHand', newTableData)
			} catch (error) {
				console.log(error)
			}
		}
	}

	const { data: packageServicesData = [] } = useQuery({
		queryKey: ['packageServices'],
		queryFn: fetchPackageServicesNoPagination,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: bpBalanceData = [] } = useQuery({
		queryKey: ['bpBalance', clientCode],
		queryFn: fetchBpBalance,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		enabled: !!clientCode,
	})

	const {
		data: clientsData = [],
		isLoading: loadingClient,
		refetch,
	} = useQuery({
		queryKey: [
			'clients',
			searchClientName,
			'50',
			'api/businesspartners/mijozlar',
		],
		queryFn: fetchClientsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: itemsData = [], isLoading: itemsLoading } = useQuery({
		queryKey: ['items', searchItemName, 'Окно', 'api/items/get-items'],
		queryFn: fetchItemsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: serviceItemsData = [] } = useQuery({
		// Bu toggleServicesCombinedni ichida ishlatilgan bu hamma uslugalarni olib keladi modalServicega bolmasdan
		queryKey: ['serviceItems', '', '', 'api/items/get-items'],
		queryFn: fetchItemsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: expensesItemsResData = [] } = useQuery({
		// Bu Xarajatlar uslugalarini olish uchun qilindi
		queryKey: ['expensesItems', 'Xarajatlar'],
		queryFn: fetchExpensesItems,
		keepPreviousData: false,
		refetchOnWindowFocus: false,
	})

	const { data: rombikItemsData = [] } = useQuery({
		queryKey: ['rombikItems'],
		queryFn: fetchRombikItems,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: telefonItemsData = [] } = useQuery({
		queryKey: ['telefonItems'],
		queryFn: fetchTelefonItems,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: kalitShapedData = [] } = useQuery({
		queryKey: ['kalitShapes'],
		queryFn: fetchKalitShapes,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: warehouseData = [], isLoading: whsLoading } = useQuery({
		queryKey: ['warehouses'],
		queryFn: fetchWarehouse,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: departmentData = [], isLoading: departmentLoading } =
		useQuery({
			queryKey: ['departments'],
			queryFn: fetchDepartments,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
		})

	const { data: slpData = [], isLoading: slpLoading } = useQuery({
		queryKey: ['salesPerson'],
		queryFn: fetchSalesPerson,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	useEffect(() => {
		if (!serviceItemsData?.length || !tableData?.length) return

		const firstRow = tableData[0]

		if (!firstRow?.selectedServices) return

		const hasDelivery = firstRow.selectedServices.some(
			(item) => item.itemCode === 'delivery',
		)

		if (hasDelivery) return

		const deliveryItem = serviceItemsData.find(
			(item) => item.itemCode === 'delivery',
		)

		if (!deliveryItem) return

		const updatedTable = [...tableData]
		updatedTable[0] = {
			...updatedTable[0],
			selectedServices: [
				...updatedTable[0].selectedServices,
				{
					lineNum: updatedTable[0].selectedServices.length,
					...deliveryItem,
				},
			],
		}

		setDefaultService(deliveryItem)
		setTableData(updatedTable)
	}, [serviceItemsData])

	useEffect(() => {
		if (!expensesItemsResData?.length) return
		setExpensesItems(expensesItemsResData)
	}, [expensesItemsResData])

	const syncSelectedServicesQuantity = (
		services,
		quantity,
		width,
		height,
		rowKey,
	) => {
		const isList = Array.isArray(services)
		const list = isList ? services || [] : [services]

		const result = list.map((service) => {
			const isCircleService =
				service.u_Modal === 'Circle_Services' && service.ugpName === 'м'

			let nextQuantity = isCircleService
				? circleServiceQuantity(width, quantity)
				: service.ugpName !== 'шт' && service.u_Modal !== "Templete_Services" && service.u_Modal !== "Telefon" && service.u_Modal !== "ort"
					? quantity
					: service.quantity

			const inputValuesForRow =
				inputValues[`${rowKey}${service.itemCode}`] || []

			if (inputValuesForRow.length > 0) {
				if (service.itemCode === 'Circle') {
					const value = parseFloat(inputValuesForRow[0] || 0)
					nextQuantity = circleShapeQuantity(value)
				} else if (service.itemCode === 'SemiCircle') {
					const value = parseFloat(inputValuesForRow[0] || 0)
					nextQuantity = semiCircleShapeQuantity(value)
				} else {
					nextQuantity = shapeSidesQuantity(inputValuesForRow)
				}
			}

			return {
				...service,
				width,
				height,
				itemQuantity: quantity,
				u_PlannedQuantity: quantity,
				quantity: nextQuantity,
			}
		})

		return isList ? result : result[0]
	}

	const columns = [
		{
			title: t('item'),
			dataIndex: 'itemCode',
			key: 'itemCode',
			fixed: 'left',
			width: 250,
			render: (_, record, index) => (
				<AutoComplete
					loading={itemsLoading}
					options={itemsData?.map((item) => ({
						value: item.itemCode,
						label: item.itemName,
						data: {
							ugpName: item.ugpName,
							price: item.price,
							koefitsent: item.u_DefaultCoefficient || 1,
							u_Number: item.u_Number,
							u_Timer: item.u_Timer,
							u_ProductionNumber: item.u_ProductionNumber,
						},
					}))}
					className="w-full "
					value={record.itemName}
					onSelect={async (value, label) => {
						if (!whs) {
							const updatedData = tableData.map((row) =>
								row.key === record.key
									? {
											...row,
											itemCode: '',
											itemName: '',
										}
									: row,
							)
							handleItemNameChange('')
							setTableData(updatedData)
							return message.error(
								'Склад не выбран, сначала выберите склад',
							)
						}

						const url = `api/items/inventory-items?itemCode=${value}`
						const { data } = await http.get(url).catch((error) => {
							message.error(error.response.data.message)
							return
						})
						const amountInWhs = data.data[0]?.inventoryItemWhs
							.filter((item) => item.whsCode == whs)
							.map((item) => item.onHand)

						const updatedData = tableData.map((row) =>
							row.key === record.key
								? {
										...row,
										itemCode: label.value,
										itemName: label.label || '',
										quantity: '',
										ugpName: label?.data?.ugpName || '',
										price: label?.data?.price || '',
										lineTotal: '',
										disabled: false,
										koefitsent:
											label?.data?.koefitsent || 1,
										u_Number: label?.data?.u_Number || '',
										u_Timer: label?.data?.u_Timer || '',
										u_ProductionNumber:
											label?.data?.u_ProductionNumber ||
											'',
										amountInWhs,
									}
								: row,
						)
						handleItemNameChange('')
						setTableData(updatedData)
					}}
					disabled={record.disabled}
					onChange={(val) => {
						const value = val || ''
						handleItemNameChange(value)
						const updatedData = tableData.map((row) =>
							row.key === record.key
								? {
										...row,
										itemName: value || '',
									}
								: row,
						)
						setTableData(updatedData)
					}}
					showSearch
				/>
			),
		},
		{
			title: `${t('width')} (${t('mm')})`,
			dataIndex: 'width',
			key: 'width',
			width: 150,
			render: (_, record) => (
				<Input
					value={formatNumberWithSpaces(record.width)}
					className={'w-full'}
					onChange={(e) => {
						const updatedData = tableData.map((row) => {
							if (row.key === record.key) {
								const rawInput = e.target.value

								// Sanitize the raw input (remove spaces and non-numeric characters)
								const sanitizedWidth = rawInput
									.replace(/[^0-9.,]/g, '')
									.replace(/\s+/g, '')

								// Parse as number for calculations
								const width =
									parseFloat(
										sanitizedWidth.replace(',', '.'),
									) || 0

								return {
									...row,
									width,
									selectedServices: syncSelectedServicesQuantity(
										row.selectedServices,
										row.quantity,
										width,
										row.height,
										row.key,
									),
								}
							}
							return row
						})
						setTableData(updatedData)
					}}
				/>
			),
		},
		{
			title: `${t('height')} (${t('mm')})`,
			dataIndex: 'height',
			key: 'height',
			width: 150,
			render: (_, record) => (
				<Input
					value={formatNumberWithSpaces(record.height)}
					className={'w-full'}
					onChange={(e) => {
						const updatedData = tableData.map((row) => {
							if (row.key === record.key) {
								const rawInput = e.target.value

								const height =
									parseFloat(
										removeSpaces(rawInput).replace(
											',',
											'.',
										),
									) || 0

								return {
									...row,
									height,
									selectedServices: syncSelectedServicesQuantity(
										row.selectedServices,
										row.quantity,
										row.width,
										height,
										row.key,
									),
								}
							}
							return row
						})

						setTableData(updatedData)
					}}
				/>
			),
		},
		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			width: 150,
			render: (_, record) => (
				<Input
					value={formatNumberWithSpaces(record.quantity)}
					className="w-full"
					onChange={(e) => {
						const rawInput = e.target.value

						const updatedData = tableData.map((row) => {
							if (row.key === record.key) {
								const quantity =
									parseFloat(
										removeSpaces(rawInput).replace(
											',',
											'.',
										),
									) || 0

								return {
									...row,
									quantity,
									selectedServices: syncSelectedServicesQuantity(
										row.selectedServices,
										quantity,
										row.width,
										row.height,
										row.key,
									),
								}
							}
							return row
						})

						setTableData(updatedData)
					}}
				/>
			),
		},
		{
			title: t('kv.m'),
			dataIndex: 'ugpName',
			key: 'ugpName',
			width: 150,
			render: (_, record) => {
				const koef = 1
				const totalWithKoef =
					calculateKvm(record.width, record.height) *
					parseFloat(record.quantity || 0) *
					koef

				// console.log(
				// 	'record = ',
				// 	record.width,
				// 	record.height,
				// 	calculateKvm(record.width, record.height),
				// )

				return (
					<span className="w-full">
						{numberWithSpacesIntl(totalWithKoef)}
					</span>
				)
			},
		},
		{
			title: t('pricePerKv'),
			dataIndex: 'price',
			key: 'price',
			width: 170,
			render: (_, record) => (
				<span className="w-full">
					{numberWithSpacesIntl(record.price || 0)}
				</span>
			),
		},
		// Uslugi modalga kirish bu joyda agar ugpName sht bolsa uni narxga qoshmaslik aks xolda uni userga usligi yozuvi orniga korastish kerak
		{
			title: t('services'),
			key: 'services',
			width: 120,
			render: (_, record) => {
				const servicesTotal = record.selectedServices
					? record.selectedServices.reduce((acc, service) => {
							if (
								service.ugpName !== 'шт' &&
								service.ugpName !== 'м' &&
								service.u_Modal !== 'Templete_Services' &&
								service.u_Modal !== 'ort' &&
								service.u_Modal !== 'Key_Sketches'
							) {
								return acc + service.price
							}
							return acc
						}, 0) *
							(record.quantity *
								((record.width * record.height) / 1000000) *
								1) +
						calculateShtPrices(record.selectedServices) +
						calculateMetrPriceServices(record?.selectedServices) +
						calculateMetrPriceParametr(record?.selectedServices)
					: 0
				return (
					<div className="flexw- full items-center justify-center">
						<Button
							type="primary"
							onClick={() => {
								setIsModalOpen(true)
								setCurrentRecord(record)
								setSelectedServices(
									record.selectedServices || [],
								)
								console.log(
									'record.selectedServices',
									record.selectedServices,
									record.selectedServices.reduce(
										(acc, service) => {
											if (
												service.ugpName !== 'шт' &&
												service.ugpName !== 'м' &&
												service.u_Modal !==
													'Templete_Services' &&
												service.u_Modal !== 'ort' &&
												service.u_Modal !==
													'Key_Sketches'
											) {
												return acc + service.price
											}
											return acc
										},
										0,
									) *
										(record.quantity *
											((record.width * record.height) /
												1000000) *
											1),
									calculateShtPrices(record.selectedServices),
									calculateMetrPriceServices(
										record?.selectedServices,
									),
									calculateMetrPriceParametr(
										record?.selectedServices,
									),
								)
							}}
						>
							{record.width > 0 ||
							record.height > 0 ||
							record.quantity > 0
								? numberWithSpacesIntl(servicesTotal)
								: t('services')}
						</Button>
					</div>
				)
			},
		},
		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			width: 170,
			render: (_, record, index) => {
				// console.log('record = ', index, record)
				const selectedPrices = calculateKvmPrices(
					record?.selectedServices,
				)
				const shtPrices = calculateShtPrices(record?.selectedServices)

				const koef = 1
				const totalWithKoef = calculateTotalWithKoef(
					record.width,
					record.height,
					record.quantity,
					koef,
				)

				const metrPricesServices = calculateMetrPriceServices(
					record?.selectedServices,
				)

				const metrPricesParametr = calculateMetrPriceParametr(
					record?.selectedServices,
				)

				const lineTotal =
					calculateLineTotal(
						record.price,
						selectedPrices,
						totalWithKoef,
					) +
					shtPrices +
					metrPricesServices +
					metrPricesParametr

				return <span>{numberWithSpacesIntl(lineTotal || 0)}</span>
			},
		},
		{
			title: t('actions'),
			key: 'actions',
			width: 100,

			render: (_, record) => (
				<div className="flex gap-2 items-center justify-center">
					<Button type="primary" onClick={addRow}>
						+
					</Button>
					<Button type="primary" onClick={() => copyRow(record)}>
						<CopyIcon />
					</Button>
					<Button
						danger
						type={'primary'}
						onClick={() => removeRow(record.key)}
						disabled={tableData.length === 1}
					>
						-
					</Button>
				</div>
			),
		},
	]

	const columnsServices = [
		{
			title: '',
			dataIndex: 'svg',
			key: 'svg',

			render: (_, record) => {
				return renderServiceTypeSvg(record.u_ServiceType)
			},
		},
		{
			title: t('service'),
			dataIndex: 'itemName',
			key: 'itemName',
			render: (text, record) => (
				<span>
					<span className="font-bold">
						{record.u_Number ? `${record.u_Number} ` : ''}
					</span>
					{`${text}`}
				</span>
			),
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text) => (
				<span>{text !== null ? numberWithSpacesIntl(text) : ''}</span>
			),
		},
		{
			title: t('measureUnit'),
			dataIndex: 'ugpName',
			key: 'ugpName',
			render: (text, record) => (
				<span>
					{text !== null
						? record.itemName.includes('GRAVIROVKA')
							? 'м'
							: text
						: ''}
				</span>
			),
		},
		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			width: 150,
			render: (_, record) =>
				record.ugpName === 'шт' ? (
					<Input
						value={
							selectedServices.find(
								(service) =>
									service.itemCode === record.itemCode,
							)?.quantity || ''
						}
						key={`${currentRecord.key}`}
						className={'w-full'}
						disabled={
							!selectedServices.some(
								(service) =>
									service.itemCode === record.itemCode,
							)
						}
						onChange={(e) => {
							const inputQuantity = e.target.value

							// Update only the service that matches the record's itemCode
							const updatedSelectedServices =
								selectedServices.map((service) =>
									service.itemCode === record.itemCode
										? {
												...service,
												quantity: inputQuantity,
											}
										: service,
								)

							setSelectedServices(updatedSelectedServices)

							// Update the tableData for the specific record
							const updatedData = tableData.map((row) => {
								if (row.key === record.key) {
									const selectedServicesTotal =
										updatedSelectedServices.reduce(
											(acc, service) =>
												acc +
												service.price *
													(service.quantity || 0),
											0,
										)
									const koef = 1
									const totalWithKoef =
										calculateTotalWithKoef(
											row.width,
											row.height,
											inputQuantity,
											koef,
										)
									const lineTotal = calculateLineTotal(
										row.price,
										selectedServicesTotal,
										totalWithKoef,
									)

									return {
										...row,
										quantity: inputQuantity,
										lineTotal,
									}
								}
								return row
							})

							setTableData(updatedData)
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				) : (
					''
				),
		},
		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => {
				const isChecked = selectedServices.some(
					(service) => service.itemCode === itemCode,
				)
				return (
					<Checkbox
						checked={isChecked}
						onChange={(e) => {
							toggleServiceSelection(record.itemCode)
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				)
			},
		},
	]

	const columnsOtgruzka = [
		{
			title: t('service'),
			dataIndex: 'itemName',
			key: 'itemName',
			render: (text, record) => (
				<span>
					<span className="font-bold">
						{record.u_Number ? `${record.u_Number} ` : ''}
					</span>
					{`${text}`}
				</span>
			),
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text) => (
				<span>{text !== null ? numberWithSpacesIntl(text) : ''}</span>
			),
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => {
				const isChecked = selectedServices.some(
					(service) => service.itemCode === itemCode,
				)
				return (
					<Checkbox
						checked={isChecked}
						onChange={(e) => {
							toggleServiceSelection(record.itemCode)
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				)
			},
		},
	]

	const columnsKalitParametrs = [
		{
			title: t('service'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					{/* <span>{record.itemCode}</span> */}
					<span>
						{record.itemCode === 'Circle' ||
						record.itemCode === 'SemiCircle'
							? t('mm')
							: t('mm')}
					</span>
				</div>
			),
		},
		{
			title: t('itemName'),
			dataIndex: 'itemName',
			key: 'itemName',
		},
		{
			title: t('sizeType'),
			dataIndex: 'sizeType',
			key: 'sizeType',
			render: (text, record, index) => (
				<Radio.Group
					value={
						selectedServices.find(
							(service) => service.itemCode === record.itemCode,
						)?.u_SizeType || ''
					}
					className="flex flex-col gap-3 min-w-[140px]"
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
				>
					{record.priceLines
						?.map((item) => ({
							value: item.u_SizeType,
							label: item.u_SizeType,
							data: item,
						}))
						?.map((opt) => (
							<Radio
								key={opt.value}
								value={opt.value}
								onClick={(e, opt) => {
									e.stopPropagation()
								}}
								onChange={(e, opt) => {
									const index = selectedServices.findIndex(
										(service) =>
											service.itemCode ===
											record.itemCode,
									)

									const selectedPriceLine =
										record.priceLines.find(
											(service) =>
												service.u_SizeType ===
												e.target.value,
										)

									const updatedServices = [
										...selectedServices,
									]
									updatedServices[index] = {
										...updatedServices[index],
										u_SizeType: e.target.value,
										price: selectedPriceLine?.u_Price,
										U_Elektr_rasxod:
											selectedPriceLine?.U_Elektr_rasxod,
										U_Stanok_rasxod:
											selectedPriceLine?.U_Stanok_rasxod,
									}
									setSelectedServices(updatedServices)
								}}
							>
								{opt.label}
							</Radio>
						))}
				</Radio.Group>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const parametrsInfo = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)

				// console.log('parametrsInfo', parametrsInfo)

				return (
					<span>
						{parametrsInfo?.price
							? formatNumberWithSpaces(parametrsInfo.price)
							: ''}
					</span>
				)
			},
		},
		// {
		// 	title: t('size'),
		// 	dataIndex: 'itemCode',
		// 	key: 'inputs',
		// 	render: (itemCode, record) => {
		// 		const isSelected = selectedServices.some(
		// 			(service) => service.itemCode === record.itemCode,
		// 		)
		// 		return (
		// 			<div>
		// 				{renderInputs(
		// 					itemCode,
		// 					`${currentRecord.key}${itemCode}`,
		// 					isSelected,
		// 				)}
		// 			</div>
		// 		)
		// 	},
		// },
		{
			title: t('quantity'),
			dataIndex: 'itemCode',
			key: 'inputs',
			render: (itemCode, record) => {
				const isSelected = selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
				return (
					<div>
						{renderInputsParametrQuantity(
							itemCode,
							`${currentRecord.key}${itemCode}`,
							isSelected,
						)}
					</div>
				)
			},
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => (
				<Checkbox
					checked={selectedServices.some(
						(service) => service.itemCode === itemCode,
					)}
					onChange={(e) => {
						toggleKalitParametrSelection(itemCode, record.key)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
				/>
			),
		},
	]

	const columnsRombikParametrs = [
		{
			title: t('service'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					{/* <span>{record.itemCode}</span> */}
					<span>
						{record.itemCode === 'Circle' ||
						record.itemCode === 'SemiCircle'
							? t('mm')
							: t('mm')}
					</span>
				</div>
			),
		},

		{
			title: t('itemName'),
			dataIndex: 'itemName',
			key: 'itemName',
		},
		{
			title: t('typeOfGrinding'),
			dataIndex: 'serviceType',
			key: 'serviceType',
			render: (text, record, index) => (
				<Radio.Group
					value={
						selectedServices.find(
							(service) => service.itemCode === record.itemCode,
						)?.u_SharepeningType || ''
					}
					className="flex flex-col gap-3 min-w-[140px]"
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
				>
					{record.priceLines
						?.map((item) => ({
							value: item.u_ServiceType,
							label: item.u_ServiceType,
							data: item,
						}))
						?.map((opt) => (
							<Radio
								key={opt.value}
								value={opt.value}
								onClick={(e, opt) => {
									e.stopPropagation()
								}}
								onChange={(e, opt) => {
									const index = selectedServices.findIndex(
										(service) =>
											service.itemCode ===
											record.itemCode,
									)

									const selectedPriceLine =
										record.priceLines.find(
											(service) =>
												service.u_ServiceType ===
												e.target.value,
										)
									console.log(
										'selectedPriceLine',
										selectedPriceLine,
									)

									const updatedServices = [
										...selectedServices,
									]
									updatedServices[index] = {
										...updatedServices[index],
										u_SharepeningType: e.target.value,
										price: selectedPriceLine?.u_Price,
										U_Elektr_rasxod:
											selectedPriceLine?.U_Elektr_rasxod,
										U_Stanok_rasxod:
											selectedPriceLine?.U_Stanok_rasxod,
									}
									setSelectedServices(updatedServices)
								}}
							>
								{opt.label}
							</Radio>
						))}
				</Radio.Group>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const parametrsInfo = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)

				// console.log('parametrsInfo', parametrsInfo)

				return (
					<span>
						{parametrsInfo?.price
							? formatNumberWithSpaces(parametrsInfo.price)
							: ''}
					</span>
				)
			},
		},
		{
			title: t('size'),
			dataIndex: 'itemCode',
			key: 'inputsSize',
			render: (itemCode, record) => {
				const isSelected = selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
				return (
					<div>
						{renderInputs(
							itemCode,
							`${currentRecord.key}${itemCode}`,
							isSelected,
						)}
					</div>
				)
			},
		},
		{
			title: t('quantity'),
			dataIndex: 'itemCode',
			key: 'inputs',
			render: (itemCode, record) => {
				const isSelected = selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
				return (
					<div>
						{renderInputsParametrQuantity(
							itemCode,
							`${currentRecord.key}${itemCode}`,
							isSelected,
						)}
					</div>
				)
			},
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => (
				<Checkbox
					checked={selectedServices.some(
						(service) => service.itemCode === itemCode,
					)}
					onChange={(e) => {
						toggleRombikParametrSelection(itemCode, record.key)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
				/>
			),
		},
	]

	const columnsTelefonParametrs = [
		{
			title: t('service'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					{/* <span>{record.itemCode}</span> */}
					<span>
						{record.itemCode === 'Circle' ||
						record.itemCode === 'SemiCircle'
							? t('mm')
							: t('mm')}
					</span>
				</div>
			),
		},

		{
			title: t('itemName'),
			dataIndex: 'itemName',
			key: 'itemName',
		},
		{
			title: t('typeOfGrinding'),
			dataIndex: 'serviceType',
			key: 'serviceType',
			render: (text, record, index) => (
				<Radio.Group
					value={
						selectedServices.find(
							(service) => service.itemCode === record.itemCode,
						)?.u_SharepeningType || ''
					}
					className="flex flex-col gap-3 min-w-[140px]"
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
				>
					{record.priceLines
						?.map((item) => ({
							value: item.u_ServiceType,
							label: item.u_ServiceType,
							data: item,
						}))
						?.map((opt) => (
							<Radio
								key={opt.value}
								value={opt.value}
								onClick={(e, opt) => {
									e.stopPropagation()
								}}
								onChange={(e, opt) => {
									const index = selectedServices.findIndex(
										(service) =>
											service.itemCode ===
											record.itemCode,
									)

									const selectedPriceLine =
										record.priceLines.find(
											(service) =>
												service.u_ServiceType ===
												e.target.value,
										)
									console.log(
										'selectedPriceLine',
										selectedPriceLine,
									)

									const updatedServices = [
										...selectedServices,
									]
									updatedServices[index] = {
										...updatedServices[index],
										u_SharepeningType: e.target.value,
										price: selectedPriceLine?.u_Price,
										U_Elektr_rasxod:
											selectedPriceLine?.U_Elektr_rasxod,
										U_Stanok_rasxod:
											selectedPriceLine?.U_Stanok_rasxod,
									}
									setSelectedServices(updatedServices)
								}}
							>
								{opt.label}
							</Radio>
						))}
				</Radio.Group>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const parametrsInfo = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)

				// console.log('parametrsInfo', parametrsInfo)

				return (
					<span>
						{parametrsInfo?.price
							? formatNumberWithSpaces(parametrsInfo.price)
							: ''}
					</span>
				)
			},
		},

		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			render: (itemCode, record) => {
				const quantity = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)?.quantity
				return (
					<span>
						{quantity ? formatNumberWithSpaces(quantity) : ''}
					</span>
				)
			},
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => (
				<Checkbox
					checked={selectedServices.some(
						(service) => service.itemCode === itemCode,
					)}
					onChange={(e) => {
						toggleTelefonParametrSelection(itemCode, record.key)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
				/>
			),
		},
	]

	const columnsShablonParametrs = [
		{
			title: t('chizma'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					<span>{record.itemName}</span>
				</div>
			),
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			width: 150,
			render: (itemCode, record) => (
				<div className="text-center">
					{/* Radio, not Checkbox: only one shablon figure can be chosen. */}
					<Radio
						checked={selectedServices.some(
							(service) => service.itemCode === itemCode,
						)}
						onChange={(e) => {
							toggleShablonParametrSelection(itemCode)
						}}
						disabled={selectedServices.every(
							(service) => !service.isShablonService,
						)}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				</div>
			),
		},
	]

	const columnsShablonServices = [
		{
			title: t('service'),
			dataIndex: 'itemName',
			key: 'itemName',
			render: (text, record) => (
				<span>
					<span className="font-bold">
						{record.u_Number ? `${record.u_Number} ` : ''}
					</span>
					{`${text}`}
				</span>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text) => (
				<span>{text !== null ? numberWithSpacesIntl(text) : ''}</span>
			),
		},
		{
			title: t('measureUnit'),
			dataIndex: 'ugpName',
			key: 'ugpName',
			render: (text) => <span>{text !== null ? text : ''}</span>,
		},
		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			width: 150,
			render: (_, record) => (
				// record.ugpName === 'шт' ? (
				<Input
					value={
						selectedServices.find(
							(service) => service.itemCode === record.itemCode,
						)?.quantity || ''
					}
					key={`${currentRecord.key}`}
					className={'w-full'}
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
					onChange={(e) => {
						const inputQuantity = e.target.value

						// Update only the service that matches the record's itemCode
						const updatedSelectedServices = selectedServices.map(
							(service) =>
								service.itemCode === record.itemCode
									? {
											...service,
											quantity: inputQuantity,
										}
									: service,
						)

						setSelectedServices(updatedSelectedServices)

						// Update the tableData for the specific record
						const updatedData = tableData.map((row) => {
							if (row.key === record.key) {
								const selectedServicesTotal =
									updatedSelectedServices.reduce(
										(acc, service) =>
											acc +
											service.price *
												(service.quantity || 0),
										0,
									)
								const koef = 1
								const totalWithKoef = calculateTotalWithKoef(
									row.width,
									row.height,
									inputQuantity,
									koef,
								)
								const lineTotal = calculateLineTotal(
									row.price,
									selectedServicesTotal,
									totalWithKoef,
								)

								return {
									...row,
									quantity: inputQuantity,
									lineTotal,
								}
							}
							return row
						})

						setTableData(updatedData)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
				/>
			),
			// ) : (
			// 	''
			// ),
		},
		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => {
				const isChecked = selectedServices.some(
					(service) => service.itemCode === itemCode,
				)
				return (
					<Checkbox
						checked={isChecked}
						onChange={(e) => {
							toggleShablonServiceSelection(record.itemCode)
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				)
			},
		},
	]

	const columnsItemsImages = [
		{
			title: t('chizma'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					<span>{record.itemName}</span>
				</div>
			),
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			width: 150,
			render: (itemCode, record) => (
				<div className="text-center">
					<Checkbox
						checked={selectedServices.some(
							(service) => service.itemCode === itemCode,
						)}
						onChange={(e) => {
							toggleItemsImagesSelection(itemCode)
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				</div>
			),
		},
	]

	const columnsKoefitsent = [
		{
			title: t('item'),
			dataIndex: 'itemName',
			key: 'itemName',
			width: 200,
		},
		{
			title: t('kv.m'),
			dataIndex: 'lineTotalWithKoef',
			key: 'lineTotalWithKoef',
			render: (totalWithKoef) => (
				<span className="w-full">
					{numberWithSpacesIntl(totalWithKoef)}
				</span>
			),
		},
		{
			title: t('amountInWhs'),
			dataIndex: 'amountInWhs',
			key: 'amountInWhs',
			render: (text) => (
				<span className="w-full">
					{text ? new Intl.NumberFormat().format(text) : text}
				</span>
			),
		},
		{
			title: t('actions'),
			dataIndex: 'amountInWhs',
			key: 'amountInWhs',
			render: (text) => (
				<span className="w-full">
					{+text <= 0 && <Tag color="red">{t('itemIsNotInWhs')}</Tag>}
				</span>
			),
		},
		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (_, record) => {
				const selectedPrices = calculateKvmPrices(
					record?.selectedServices,
				)

				const koef = record.koefitsent || 1
				const totalWithKoef = record.lineTotalWithKoef * koef // Use the precomputed summarized value

				const shtPrices = calculateShtPrices(selectedServices)

				const metrPricesServices =
					calculateMetrPriceServices(selectedServices)

				const metrPricesParametr =
					calculateMetrPriceParametr(selectedServices)

				//	Bunda usluga,item,Figuraniki hisoblidi koefitsent bn
				const lineTotal = calculateLineTotal(
					record.price,
					0, //Endi Uslugalarni Narxini koefitsent bn hisoblanmidi
					totalWithKoef,
				)

				//	Bunda faqat itemmikini hisoblidi koefitsent bn
				// const lineTotal =
				// 	calculateLineTotal(
				// 		record.price,
				// 		0, //Endi Uslugalarni Narxini koefitsent bn hisoblanmidi
				// 		totalWithKoef,
				// 	) + selectedPrices

				// Update the summarized record with the calculated lineTotal (optional)
				record.lineTotal = lineTotal

				return (
					<span className="w-full">
						{numberWithSpacesIntl(lineTotal || 0)}
					</span>
				)
			},
		},
		{
			title: t('Koefitsent'),
			dataIndex: 'koefitsent',
			key: 'koefitsent',
			render: (_, record) => {
				return (
					<div className="flex flex-col gap-3 ">
						<Input
							type="number"
							onWheel={(e) => e.target.blur()}
							min={-1}
							suffix="%"
							controls={false}
							value={record.koefitsent}
							disabled={!isAdmin}
							onChange={(e) =>
								handleKoefitsentChange(
									e.target.value,
									record.itemName,
								)
							}
							className="w-full"
						/>
						{record.koefitsent <= 0 && (
							<Tag color="red">{t('koefitsentLessThanZero')}</Tag>
						)}
					</div>
				)
			},
		},
	]

	const switchExpensePrice = (itemCode) => {
		switch (itemCode) {
			case arendaTotal?.itemCode:
				return arendaTotal?.total
				break

			case stanokTotal?.itemCode:
				return stanokTotal?.total
				break
			case ishHaqiTotal?.itemCode:
				return ishHaqiTotal?.total
				break
			case elektrTotal?.itemCode:
				return elektrTotal?.total
				break

			default:
				break
		}
	}

	const onSubmit = async () => {
		console.log('tableData = ', tableData)
		console.log('docTotal = ', docTotal, inputDocTotal,)

		const originalDocTotal = Number(docTotal) || 0

		if (!clientCode) return message.error('Клиент не выбран')
		if (!inputDocTotal) return message.error('Общая сумма не указана')
		if (!isAdmin && inputDocTotal < originalDocTotal) {
			setInputDocTotal(originalDocTotal)
			setIsDiscountBigger(false)
			return message.error('Общая сумма меньше суммы товаров')
		}
		if (!date) return message.error('Дата срока не выбрана')
		if (!currency) return message.error('Валюта не выбрана')
		if (!departmentAdmin) return message.error('Отдел не выбран')
		if (!slpAdmin) return message.error('Менеджер продаж не выбран')
		if (!whs) return message.error('Склад не выбран')
		if (!get(getMe, 'employeeId', ''))
			return message.error('EmployeeId не задан')
		if (tableData.length === 0) return message.error('Таблица пустая')
		if (tableData?.some((row) => !row.itemCode))
			return message.error('Товар не выбран')
		if (tableData?.some((row) => !row.koefitsent || row.koefitsent <= 0))
			return message.error('Коэффициент должен быть больше 0')

		const photoId = (imageList || [])
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')

		setIsBtnLoading(true)

		const prevLocation = sessionStorage.getItem('prevLocation')

		try {
			let lineNumber = 0 // Initialize line number counter

			console.log('tableData = ', tableData)

			const totalItemsQuantity = tableData.reduce((total, row) => {
				return (
					total +
					Number(row.quantity) * +calculateKvm(row.width, row.height)
				)
			}, 0)
			const totalItemsPlannedQty = tableData.reduce((total, row) => {
				return (
					total +
					Number(row.quantity)
				)
			}, 0)

			console

			const data = {
				cardCode: clientCode,
				docDate: dateSale,
				docDueDate: date,
				docTotal: inputDocTotal,
				documentOwner: get(getMe, 'employeeId', ''),
				salesPersonCode: slpAdmin,
				comments: comments,
				u_ChertejId: photoId,
				docCurrency: currency,
				department: departmentAdmin,
				u_DueDays: inputDateCount,
				documentLines: [
					...(Array.isArray(tableData)
						? tableData.map((row) => ({
								lineNum: lineNumber++, // Increment line number
								itemCode: row.itemCode,
								quantity: Number(
									row.quantity *
										calculateKvm(row.width, row.height),
								),
								unitPrice:
									Number(row.price) * +(row.koefitsent || 1),
								currency: row.currency,
								warehouseCode: whs,
								u_uslugaID: Number(row.lineNum),
								u_Produkt: null,
								u_Kvmetr: calculateKvm(row.width, row.height),
								u_Width: row.width,
								u_Height: row.height,
								u_Coefficient: row.koefitsent,
								u_Timer: null,
								u_PlannedQuantity: row.quantity,
								u_Number: row.u_Number || '',
								u_ItemGroup: 'Item',
								u_FigureQuantity: 0,
								u_ShapeSides: '',
								u_SizeType: '',
								u_SharepeningType: '',
								u_ConnectedShape: '',
								u_Modal: '',
								discountPercent: 0,
								u_ProductionNumber: row.u_ProductionNumber,
								u_ElectricityCost:
									switchExpensePrice(elektrTotal?.itemCode) /
										+totalItemsQuantity || 0,
								u_MachineCost:
									switchExpensePrice(stanokTotal?.itemCode) /
										+totalItemsQuantity || 0,
							}))
						: []),
					...expensesItems?.map((row) => ({
						lineNum: lineNumber++, // Increment line number
						itemCode: row.itemCode,
						quantity:
							row.itemCode === elektrTotal.itemCode ||
							row.itemCode === stanokTotal.itemCode
								? 1
								: totalItemsQuantity,
						unitPrice: (
							switchExpensePrice(row.itemCode) /
							(row.itemCode === elektrTotal.itemCode ||
							row.itemCode === stanokTotal.itemCode
								? 1
								: +totalItemsQuantity)
						).toFixed(2),
						currency: row.currency,
						warehouseCode: whs,
						u_uslugaID: '-1',
						u_Produkt: '-1',
						u_Kvmetr: 1,
						u_Width: '1000',
						u_Height: '1000',
						u_Coefficient: 1,
						u_Timer: null,
						u_PlannedQuantity: row.itemCode === elektrTotal.itemCode ||
							row.itemCode === stanokTotal.itemCode ? totalItemsPlannedQty : totalItemsQuantity,// eski xolatida faqat  totalItemsQuantity ketardi  Bu logika orqaga qaytarilishi mumkun 30-iyuldigi  error uchun logika ozgartirildi
						u_Number: '',
						u_ItemGroup: 'Expenses',
						u_FigureQuantity: 0,
						u_ShapeSides: '',
						u_SizeType: '',
						u_SharepeningType: '',
						u_ConnectedShape: '',
						u_Modal: 'Xarajatlar',
						discountPercent: 100,
						u_ProductionNumber: '',
						u_ElectricityCost:
							switchExpensePrice(elektrTotal?.itemCode) /
								+totalItemsQuantity || 0,
						u_MachineCost:
							switchExpensePrice(stanokTotal?.itemCode) /
								+totalItemsQuantity || 0,
					})),
					...(Array.isArray(tableData)
						? tableData
								.filter((row) =>
									Array.isArray(row.selectedServices),
								)
								.flatMap((row, rowIndex) =>
									row.selectedServices.map((service) => ({
										lineNum: lineNumber++, // Increment line number
										itemCode: service.itemCode,
										quantity:
											service.u_Modal == 'ort'
												? row.quantity *
													calculateKvm(
														row.width,
														row.height,
													)
												: service.isChizma ||
													  service.isShablonParametr
													? 1
													: service.u_Modal ===
																'Templete_Services' ||
														  service.u_Modal ===
																'Telefon'
														? service.itemQuantity *
															service.quantity
														: service.ugpName ===
																	'шт' &&
															  !service.isParametr
															? service.quantity *
																service.itemQuantity
															: service.ugpName ===
																		'шт' &&
																  service.isParametr
																? +service.u_ParametrQuantityValues *
																	+service.itemQuantity
																: service.ugpName ===
																			'м' &&
																	  !service.isParametr &&
																	  service.u_Modal !==
																			'Circle_Services'
																	? perimeterQuantity(
																			row.width,
																			row.height,
																			service.quantity,
																		)
																	: service.ugpName ===
																				'м' &&
																		  !service.isParametr &&
																		  service.u_Modal ===
																				'Circle_Services'
																		? circleServiceQuantity(
																				service.width,
																				service.itemQuantity,
																			)
																		: service.ugpName ===
																					'м' &&
																			  service.isParametr
																			? +service.quantity *
																				+service.u_ParametrQuantityValues *
																				service.itemQuantity
																			: Number(
																					+service.quantity *
																						calculateKvm(
																							row.width,
																							row.height,
																						),
																				),
										unitPrice:
											service.isChizma ||
											service.isShablonParametr
												? 0
												: Number(service.price),
										currency: service.currency,
										warehouseCode: whs,
										u_uslugaID: Number(service.lineNum),
										u_Produkt: row.itemName,
										u_Kvmetr: '',
										u_Timer: service.u_Timer,
										u_Width: row.width,
										u_Height: row.height,

										u_PlannedQuantity:
											service.u_Modal == 'ort' ||
											service?.u_Modal == 'Key_Figures' ||
											service?.u_Modal ===
												'Templete_Figures' ||
											service?.u_Modal == 'Telefon'
												? service.itemQuantity
												: service.isChizma
													? 1
													: service.ugpName === 'м' &&
														  service.isParametr
														? service.u_ParametrQuantityValues *
															row.quantity
														: (service.ugpName ===
																	'м' &&
																	!service.isParametr &&
																	service.u_Modal ==
																		'Circle_Services') ||
															  service.u_Modal ===
																	'Templete_Services' ||
															  (service.ugpName ===
																	'шт' &&
																	!service.isParametr)
															? service.itemQuantity
															: service.quantity,
										u_Coefficient:
											service.ugpName === 'шт' ||
											service.ugpName === 'м'
												? 1
												: row.koefitsent,
										u_Number: service.u_Number || '',
										u_ItemGroup: service.isChizma
											? 'Chizma'
											: service.isShablonParametr
												? 'ShablonShape'
												: service.isShablonService
													? 'ShablonService'
													: service.isParametr
														? 'Shape'
														: 'Service',
										u_ShapeSides: service.isParametr
											? service?.u_ShapeSides
											: '',
										u_SizeType: service.u_SizeType || '',
										u_SharepeningType:
											service.u_SharepeningType || '',
										u_ConnectedShape:
											service.isShablonService
												? row.selectedServices?.filter(
														(s) =>
															s.isShablonParametr,
													)?.map((s) => s.itemCode).join(',')
												: '',

										u_FigureQuantity: service.isParametr
											? service.u_ParametrQuantityValues
											: service.u_Modal ===
														'Templete_Services' ||
												  service?.u_Modal ===
														'Telefon' ||
												  (service.u_Modal ===
														'Key_Services' &&
														service.ugpName ===
															'шт') ||
												  (service.u_Modal ===
														'Circle_Services' &&
														service.ugpName ===
															'шт') // Bunda Key_Services va Circle_Services u_Modal bo'lsa sht ga yozgan quantity tushadi
												? service.quantity
												: 0,
										u_Modal: service.u_Modal || '',
										discountPercent:
											service?.u_Modal == 'ort' ? 100 : 0,
										u_ProductionNumber:
											service.u_ProductionNumber,
										u_ElectricityCost:
											service.U_Elektr_rasxod || 0,
										u_MachineCost:
											service.U_Stanok_rasxod || 0,
									})),
								)
								.sort((a, b) =>
									(a.u_Number || '').localeCompare(
										b.u_Number || '',
										undefined,
										{ numeric: true },
									),
								)
						: []),
				],
			}

			console.log('data', data)

			await http.post(
				`api/sales/sotuv-buyurtmasi?needToConfirmFromBot=${sendFile}`,
				data,
			)
			successRef.current.open(t('sucCreated'))
		} catch (error) {
			catchError(error, errorRef)
		} finally {
			setIsBtnLoading(false)
		}
	}

	const renderContent = () => {
		switch (activeTab) {
			case 'tab1':
				return (
					<>
						<span className="font-bold text-lg">
							{t('chooseServicesPackage')}
						</span>
						<div className="flex flex-col  gap-1 mt-4 mb-4">
							{packageServicesData.map((service) => (
								<div
									key={service.code}
									className="flex items-center gap-2"
								>
									<span
										className="text-blue-600 hover:text-blue-800 cursor-pointer  font-bold"
										onClick={() =>
											toggleServiceSelectionGroup(
												service.serviceLines,
											)
										}
									>
										{service.name}
									</span>
								</div>
							))}
						</div>
						<Table
							columns={columnsServices}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Key_Services',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleServiceSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab2':
				return (
					<>
						<span className="font-bold text-lg">
							{t('chooseServicesPackage')}
						</span>
						<div className="flex flex-col  gap-1 mt-4 mb-4">
							{packageServicesData.map((service) => (
								<div
									key={service.code}
									className="flex items-center gap-2"
								>
									<span
										className="text-blue-600 hover:text-blue-800 cursor-pointer  font-bold"
										onClick={() =>
											toggleServiceSelectionGroup(
												service.serviceLines,
											)
										}
									>
										{service.name}
									</span>
								</div>
							))}
						</div>

						<Table
							columns={columnsServices}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Circle_Services',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleServiceSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
						<div className="flex flex-col gap-2 mt-10">
							<span className="font-bold text-lg mb-5">
								{t('Telefon Burchak')}
							</span>
							<Table
								columns={columnsTelefonParametrs}
								dataSource={telefonItemsData?.sort((a, b) => {
									return a?.itemName.localeCompare(
										b?.itemName,
										'ru',
									)
								})}
								rowKey={(record) => record.itemCode}
								pagination={false}
							/>
						</div>
					</>
				)

			case 'tab3':
				return (
					<>
						<Table
							columns={columnsRombikParametrs}
							dataSource={rombikItemsData}
							rowKey={(record) => record.itemCode}
							pagination={false}
						/>
					</>
				)

			case 'tab4':
				return (
					<>
						<div className="mt-5 flex flex-col gap-5">
							<span className="font-bold text-sm">
								{t('Shablon Xizmatlar')}
							</span>
							<Table
								columns={columnsShablonServices}
								dataSource={serviceItemsData?.filter(
									(item) =>
										item.u_Modal === 'Templete_Services',
								)}
								rowKey={(record) => record.itemCode}
								onRow={(record) => ({
									onClick: (e) => {
										e.stopPropagation()
										toggleShablonServiceSelection(
											record?.itemCode,
										)
									},
								})}
								pagination={false}
							/>
						</div>
						<div className="mt-10 flex flex-col gap-5">
							<span className="font-bold text-sm">
								{t('Shablon Shakllari')}
							</span>
							<Table
								columns={columnsShablonParametrs}
								dataSource={serviceItemsData?.filter(
									(item) =>
										item.u_Modal === 'Templete_Figures',
								)}
								rowKey={(record) => record.itemCode}
								onRow={(record) => ({
									onClick: (e) => {
										e.stopPropagation()

										toggleShablonParametrSelection(
											record?.itemCode,
										)
									},
								})}
								pagination={false}
							/>
						</div>
					</>
				)

			case 'tab5':
				return (
					<>
						<Table
							columns={columnsKalitParametrs}
							dataSource={kalitShapedData}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								// onClick: (e) => {
								// 	e.stopPropagation()
								// 	toggleKalitParametrSelection(
								// 		record?.itemCode,
								// 		record?.key,
								// 	)
								// },
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab6':
				return (
					<>
						<Table
							columns={columnsItemsImages}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Rhombic_Sketches',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleItemsImagesSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab7':
				return (
					<>
						<Table
							columns={columnsItemsImages}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Key_Sketches',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleItemsImagesSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
					</>
				)
			case 'tab8':
				return (
					<>
						<Table
							columns={columnsOtgruzka}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'ort',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleServiceSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
					</>
				)
			default:
				return null
		}
	}

	const renderInputs = (itemCode, rowKey, isSelected) => {
		let inputCount = 1
		if (
			itemCode === 'Rectangle' ||
			itemCode === 'Parallelogram' ||
			itemCode === 'Square' ||
			itemCode === 'Asal02' ||
			itemCode === 'Rhombus' ||
			itemCode === 'Trapezoid' ||
			itemCode === 'Archa01' ||
			itemCode === 'Archa02' ||
			itemCode === 'Archa' ||
			itemCode === 'Rectangle02' ||
			itemCode === 'Trapezoid' ||
			itemCode === 'Parallelogram' ||
			itemCode === 'Archa'
		) {
			inputCount = 4
		} else if (
			itemCode === 'Qalam01' ||
			itemCode === 'Qalam02' ||
			itemCode === 'Pentagon' ||
			itemCode === 'Asal01'
		) {
			inputCount = 5
		} else if (itemCode === 'Triangle' || itemCode === 'Triangle01') {
			inputCount = 3
		} else if (itemCode === 'Octagon' || itemCode === 'Qombik') {
			inputCount = 8
		} else if (itemCode === 'Triangle02') {
			inputCount = 3
		} else if (
			itemCode === 'Pencil' ||
			itemCode === 'Qalam' ||
			itemCode === 'Qombik1' ||
			itemCode === 'Qombik2' ||
			itemCode === 'Asal'
		) {
			inputCount = 6
		} else if (
			itemCode === 'SemiCircle' ||
			itemCode === 'Oval' ||
			itemCode === 'Oval01' ||
			itemCode === 'Oval02' ||
			itemCode === 'Circle' ||
			itemCode === 'MabelShablon9' ||
			itemCode === 'MebelShablon10' ||
			itemCode === 'TelefonBurchak1'
		) {
			inputCount = 1
		} else if (itemCode !== 'Circle') {
			inputCount = 1
			//Qolgan shakllarga bitta input bo'ladi
		}

		return Array.from({ length: inputCount }, (_, index) => (
			<Input
				key={`${rowKey}-input-${index}`}
				value={inputValues[rowKey]?.[index] || ''}
				onChange={(e) => {
					handleInputChange(rowKey, index, e.target.value)
				}}
				onClick={(e) => {
					e.stopPropagation()
				}}
				className="mb-2 w-full"
				disabled={!isSelected}
			/>
		))
	}

	const renderInputsParametrQuantity = (itemCode, rowKey, isSelected) => {
		const inputCount = 1
		return Array.from({ length: inputCount }, (_, index) => (
			<Input
				key={`${rowKey}-input-${index}`}
				value={inputParametrQuantity[rowKey]?.[index] || ''}
				onChange={(e) => {
					handleParametrQuantityInputChange(
						rowKey,
						index,
						e.target.value,
					)
				}}
				onClick={(e) => {
					e.stopPropagation()
				}}
				className="mb-2 w-[100px]"
				disabled={!isSelected}
			/>
		))
	}

	const addRow = () => {
		setTableData([
			...tableData,
			{
				key: Date.now(),
				itemCode: null,
				itemName: null,
				width: '',
				height: '',
				quantity: '',
				ugpName: '',
				price: '',
				lineTotal: '',
				lineNum: tableData[tableData.length - 1].lineNum + 1,
				u_Timer: null,
				u_Number: null,
				koefitsent: 1,
				disabled: false,
				selectedServices: [
					{
						...defaultService,
						lineNum: tableData[tableData.length - 1].lineNum + 1,
					},
				],
				itemType: 'Item',
			},
		])
	}

	const copyRow = (record) => {
		setTableData([
			...tableData,
			{
				key: Date.now(),
				itemCode: record.itemCode,
				itemName: record.itemName,
				width: '',
				height: '',
				quantity: '',
				ugpName: '',
				currency: currency,
				price: record.price,
				lineTotal: '',
				lineNum: tableData[tableData.length - 1].lineNum + 1,
				u_Timer: record.u_Timer,
				u_Number: record.u_Number,
				koefitsent: record.koefitsent,
				disabled: record.disabled,
				selectedServices: [
					{
						...defaultService,
						lineNum: tableData[tableData.length - 1].lineNum + 1,
					},
				],
				itemType: record.itemType,
			},
		])
	}

	const removeRow = (key) => {
		if (tableData.length > 1) {
			setTableData(tableData.filter((row) => row.key !== key))
		}
	}

	const uploadImg = async (index) => {
		const image = imageList[index]

		if (!image.file) {
			message.error('Фотография не выбрано')
			return
		}

		const formData = new FormData()
		formData.append('file', image.file)

		const generateRandomKey = () => {
			const characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let randomKey = ''
			for (let i = 0; i < 16; i++) {
				randomKey += characters.charAt(
					Math.floor(Math.random() * characters.length),
				)
			}
			return randomKey
		}

		const randomKey = generateRandomKey()
		const title = 'YourTitle'

		formData.append('Title', title)
		formData.append('Key', randomKey)

		try {
			const updatedImageList = [...imageList]
			updatedImageList[index].imgLoading = true
			setImageList(updatedImageList)

			const res = await http.post('api/assets/upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})

			const { key } = res.data
			updatedImageList[index].path = key
			setImageList(updatedImageList)

			message.success('Успешно загружено!')
		} catch (err) {
			message.error('Ошибка загрузки')
		} finally {
			const updatedImageList = [...imageList]
			updatedImageList[index].imgLoading = false
			setImageList(updatedImageList)
		}
	}

	const viewImage = async (index) => {
		const image = imageList[index]

		try {
			const res = await http.get(`api/assets/download/${image.path}`, {
				responseType: 'blob',
			})

			const url = window.URL.createObjectURL(
				new Blob([res.data], {
					type: 'image/png',
				}),
			)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'BP.png')
			document.body.appendChild(link)
			link.click()

			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			message.error('Ошибка загрузки файла')
		}
	}

	const addNewRow = () => {
		setImageList([
			...imageList,
			{ file: null, path: '', imgLoading: false },
		])
	}

	const deleteRow = (index) => {
		setImageList(imageList.filter((_, i) => i !== index))
	}

	const handleDateChange = (e) => {
		const input = Number(e.target.value)
		setInputDateCount(input)

		if (!isNaN(input)) {
			let daysToAdd = input
			const newDate = moment()

			while (daysToAdd > 0) {
				newDate.add(1, 'days')
				if (newDate.day() !== 0) {
					daysToAdd--
				}
			}
			setDate(newDate.format('YYYY-MM-DD'))
		} else {
			console.error('Invalid input: Please input a valid number.')
		}
	}

	const handleFileChange = (event, index) => {
		const updatedImageList = [...imageList]
		updatedImageList[index].file = event.target.files[0]
		setImageList(updatedImageList)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setSearchClientName)
	}

	const handleItemNameChange = (val) => {
		debouncedSet(val, setSearchItemName)
	}

	const handleKoefitsentChange = (value, itemName) => {
		setTableData((prevData) => {
			const koef = parseFloat(value) || 0
			return prevData.map((row) => {
				if (row.itemName === itemName) {
					// Update all grouped rows
					console.log('row', row)
					const selectedPrices = calculateKvmPrices(
						row?.selectedServices,
					)

					const shtPrices = calculateShtPrices(selectedServices)

					const totalWithKoef = calculateTotalWithKoef(
						row.width,
						row.height,
						row.quantity,
						koef,
					)

					// const lineTotal =
					// 	calculateLineTotal(
					// 		row.price,
					// 		selectedPrices,
					// 		totalWithKoef,
					// 	) + shtPrices

					const lineTotal = calculateLineTotal(
						row.price,
						0, //Endi Uslugalarni Narxini koefitsent bn hisoblanmidi
						totalWithKoef,
					)

					return {
						...row,
						koefitsent: koef, // Store updated coefficient
						// lineTotalWithKoef: totalWithKoef, // Recalculate total
						lineTotal, // Update calculated total
					}
				}
				return row
			})
		})
	}

	const handleModalYes = () => {
		setIsConfirmModalVisible(false)
		navigate('/sales-order')
	}

	const handleModalNo = () => {
		setIsConfirmModalVisible(false)
	}

	const handleModalCancel = () => {
		setIsConfirmModalVisible(false)
	}

	const handleServiceModalYes = () => {
		setIsConfirmServiceModalVisible(false)
		setIsModalOpen(false)
	}

	const handleServiceModalNo = () => {
		setIsConfirmServiceModalVisible(false)
	}

	const handleServiceModalCancel = () => {
		setIsConfirmServiceModalVisible(false)
	}

	const handleInputChange = (rowKey, index, value) => {
		setInputValues((prev) => {
			const updatedValues = { ...prev }
			if (!updatedValues[rowKey]) {
				updatedValues[rowKey] = [] // Initialize row if not present
			}
			updatedValues[rowKey][index] = value // Set the specific input value
			return updatedValues
		})
	}

	const handleParametrQuantityInputChange = (rowKey, index, value) => {
		setInputParametrQuantity((prev) => {
			const updatedValues = { ...prev }
			if (!updatedValues[rowKey]) {
				updatedValues[rowKey] = [] // Initialize row if not present
			}
			updatedValues[rowKey][index] = value // Set the specific input value
			return updatedValues
		})
	}

	const toggleRombikParametrSelection = (itemCode, rowKey) => {
		const selectedService = rombikItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						itemName,
						ugpName,
						u_Timer,
						u_Number,
						priceLines,
						u_Modal,
						u_ProductionNumber,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							itemName,
							price:
								priceLines.length > 0
									? priceLines[0].u_Price
									: -1,
							u_SharepeningType:
								priceLines.length > 0
									? priceLines[0].u_ServiceType
									: '',
							U_Elektr_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Elektr_rasxod
									: -1,
							U_Stanok_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Stanok_rasxod
									: -1,
							lineNum,
							currency,
							itemQuantity: quantity,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							u_ProductionNumber,

							isParametr: true,
							isRombikParametr: true,
						},
					]
				}
				return newSelectedServices
			})

			// setInputValues((prev) => {
			// 	const updatedValues = { ...prev }
			// 	if (!prev[rowKey]) {
			// 		updatedValues[rowKey] = Array(10).fill('')
			// 	}
			// 	if (
			// 		selectedServices.some(
			// 			(service) => service.itemCode === itemCode,
			// 		)
			// 	) {
			// 		return updatedValues[rowKey]
			// 	}
			// 	return updatedValues
			// })
		}
	}

	const toggleTelefonParametrSelection = (itemCode, rowKey) => {
		const selectedService = telefonItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)

				let parametrQuantity

				if (itemCode === 'TelefonBurchak') {
					parametrQuantity = 1
				}

				if (itemCode === 'TelefonBurchak 2') {
					parametrQuantity = 3
				}

				if (itemCode === 'TelefonBurchak1') {
					parametrQuantity = 2
				}

				if (itemCode === 'TelefonBurchak3') {
					parametrQuantity = 4
				}

				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						itemName,
						ugpName,
						u_Timer,
						u_Number,
						priceLines,
						u_Modal,
						u_ProductionNumber,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							itemName,
							price:
								priceLines.length > 0
									? priceLines[0].u_Price
									: -1,
							u_SharepeningType:
								priceLines.length > 0
									? priceLines[0].u_ServiceType
									: '',
							U_Elektr_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Elektr_rasxod
									: -1,
							U_Stanok_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Stanok_rasxod
									: -1,
							lineNum,
							currency,
							itemQuantity: quantity,
							quantity: parametrQuantity,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							u_ProductionNumber,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleKalitParametrSelection = (itemCode, rowKey) => {
		const selectedService = kalitShapedData.find(
			(service) => service.itemCode === itemCode,
		)

		const inputParametrQuantityValues =
			inputParametrQuantity[`${currentRecord.key}${itemCode}`] || []

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						itemName,
						ugpName,
						u_Timer,
						u_Number,
						priceLines,
						u_Modal,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							itemName,
							price:
								priceLines.length > 0
									? priceLines[0].u_Price
									: -1,
							u_SizeType:
								priceLines.length > 0
									? priceLines[0].u_SizeType
									: '',
							U_Elektr_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Elektr_rasxod
									: -1,
							U_Stanok_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Stanok_rasxod
									: -1,
							lineNum,
							currency,
							itemQuantity: quantity,
							ugpName,
							u_Modal,
							u_Timer,
							u_Number,
							u_ProductionNumber,

							isParametr: true,
							isKalitParametr: true,
						},
					]
				}
				return newSelectedServices
			})

			// setInputValues((prev) => {
			// 	const updatedValues = { ...prev }
			// 	if (!prev[rowKey]) {
			// 		updatedValues[rowKey] = Array(10).fill('')
			// 	}
			// 	if (
			// 		selectedServices.some(
			// 			(service) => service.itemCode === itemCode,
			// 		)
			// 	) {
			// 		return updatedValues[rowKey]
			// 	}
			// 	return updatedValues
			// })
		}
	}

	const toggleServiceSelection = (itemCode) => {
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)
		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						itemName,
						price,
						ugpName,
						u_Timer,
						u_Number,
						u_ServiceType: uItemServiceType,
						u_Modal,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							itemName,
							price,
							lineNum,
							currency,
							quantity: ugpName !== 'шт' ? quantity : '',
							itemQuantity: quantity,
							ugpName,
							u_Timer,
							u_Number,
							uItemServiceType,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
							u_Modal,
							isParametr: false,
							isService: true,
							u_ProductionNumber,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

const toggleShablonServiceSelection = (itemCode) => {
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						itemName,
						price,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							itemName,
							price,
							lineNum,
							currency,
							itemQuantity: quantity,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							isParametr: false,
							isShablonService: true,
							isService: true,
							u_ProductionNumber,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleItemsImagesSelection = (itemCode) => {
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)
		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						itemName,
						price,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					newSelectedServices = [
						...prevSelected,
						{
							width: 0,
							height: 0,
							itemCode,
							itemName,
							price: 0,
							lineNum,
							currency,
							quantity: 0,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							isParametr: false,
							isChizma: true,
							u_ProductionNumber,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleShablonParametrSelection = (itemCode) => {
		if (selectedServices.every((service) => !service.isShablonService)) {
			return message.error('Сначала Выберите шаблонную услугу')
		}
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		const isAlreadySelected = selectedServices.some(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) => {
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						itemName,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency } = currentRecord
					newSelectedServices = [
						// Only one shablon figure may be selected, so drop any
						// previously chosen one instead of appending to it.
						...prevSelected.filter(
							(service) => !service.isShablonParametr,
						),
						{
							width: 0,
							height: 0,
							itemCode,
							itemName,
							price: 0,
							lineNum,
							currency,
							quantity: 0,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							isParametr: false,
							isChizma: false,
							isShablonParametr: true,
							u_ProductionNumber,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleServiceSelectionGroup = (line) => {
		const selectedService = line
			.map((item) =>
				serviceItemsData.find(
					(service) => service.itemCode === item.itemCode,
				),
			)
			.filter(Boolean) // Remove undefined values

		// Find itemCodes that do not exist
		const missingItemCodes = line
			.map((item) => item.itemCode)
			.filter(
				(itemCode) =>
					!serviceItemsData.some(
						(service) => service.itemCode === itemCode,
					),
			)

		// Show an error message for missing itemCodes
		if (missingItemCodes.length > 0) {
			message.error(
				`The following item codes were not found: ${missingItemCodes.join(', ')}`,
			)
		}

		if (selectedService.length > 0 && currentRecord) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = line.every((item) =>
					prevSelected.some(
						(service) => service.itemCode === item.itemCode,
					),
				)

				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) =>
							!line.some(
								(item) => item.itemCode === service.itemCode,
							),
					)
				} else {
					const newServices = selectedService.map(
						({
							itemCode,
							price,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							u_ProductionNumber,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
						}) => {
							const {
								lineNum,
								currency,
								quantity,
								width,
								height,
							} = currentRecord
							return {
								width,
								height,
								itemCode,
								price,
								lineNum,
								currency,
								quantity,
								ugpName,
								u_Modal,
								u_Timer,
								u_Number,
								u_ProductionNumber,
								isParametr: false,
								isService: true,
								U_Elektr_rasxod,
								U_Stanok_rasxod,
							}
						},
					)
					newSelectedServices = [...prevSelected, ...newServices]
				}
				return newSelectedServices
			})
		}
	}

	const handleOkCombined = () => {
		const hasShablonService = selectedServices.filter(
			(service) => service.isShablonService,
		)
		const hasShablonParametr = selectedServices.filter(
			(service) => service.isShablonParametr,
		)

		const isShanblonFullySelected =
			hasShablonService.length > 0 === hasShablonParametr.length > 0

		if (!isShanblonFullySelected) {
			message.error(
				'Если вы выбрали Шаблон услуги, то вы также должны выбрать Шаблон фигуры!',
			)
			return
		}
		const updatedSelectedServices = selectedServices.map((service) => {
			let quantity = service.quantity || 0
			let u_ParametrQuantityValues = service.u_ParametrQuantityValues || 0
			let isParametr = false
			// Calculate quantity for shapes if inputValues are present
			const inputValuesForRow =
				inputValues[`${currentRecord.key}${service.itemCode}`] || []

			console.log('service', service)

			if (
				service.u_Modal === 'Circle_Services' &&
				service.ugpName === 'м'
			) {
				quantity = circleServiceQuantity(service.width, service.itemQuantity)
			}

			if (inputValuesForRow.length > 0) {
				if (service.itemCode === 'Circle') {
					const value = parseFloat(inputValuesForRow[0] || 0)
					quantity = circleShapeQuantity(value)
					isParametr = true
				} else if (service.itemCode === 'SemiCircle') {
					const value = parseFloat(inputValuesForRow[0] || 0)
					quantity = semiCircleShapeQuantity(value)
					isParametr = true
				} else {
					quantity =
						inputValuesForRow.reduce(
							(acc, val) => acc + parseFloat(val || 0),
							0,
						) / 1000
					isParametr = true
				}
			}

			const inputParametrQuantityValues =
				inputParametrQuantity[
					`${currentRecord.key}${service.itemCode}`
				] || []

			if (inputParametrQuantityValues.length > 0) {
				u_ParametrQuantityValues = inputParametrQuantityValues.reduce(
					(acc, val) => acc + parseFloat(val || 0),
					0,
				)
				isParametr = true
			}

			// Buyoda azgina logika ozgarishi mumkun yani 	service.itemQuantity bunga ham kopaytirish qoshilishi mumkun bu itemmi tashqaridigi tabledigi yozilgan soni ozi postda (+service.quantity * 	+service.u_ParametrQuantityValues * 	service.itemQuantity) bunda service.itemQuantity  ham qoshilgan ekan  ekan
			// Ozi bunda yozilgan O'lcham inputlarini jami bilan *  yozilgan input soniga kopaytilyapti hozir Figuri modaldigi
			const totalPemitr = quantity * u_ParametrQuantityValues

			return {
				...service,
				quantity,
				u_ParametrQuantityValues: u_ParametrQuantityValues,
				totalPemitr: totalPemitr,
				isParametr,
				itemName: service.itemName,
				u_ShapeSides: inputValuesForRow
					.map((val) => val || 0)
					.join(';'),
			}
		})

		// Check if any service has quantity input from any source (quantity field, shape inputs, or parameter quantity)
		// Skip validation for Chizma, Key_Sketches, Rhombic_Sketches, Templete_Figures items as they don't require quantity
		const servicesWithoutQuantity = updatedSelectedServices.filter(
			(service) => {
				// Skip quantity validation for items that don't require quantity
				const noQuantityRequiredItems = [
					'Chizma',
					'Key_Sketches',
					'Rhombic_Sketches',
					"Templete_Figures",
					"ort"
				]
				// Check both u_ItemGroup and u_Modal fields
				if (
					noQuantityRequiredItems.includes(service.u_ItemGroup) ||
					noQuantityRequiredItems.includes(service.u_Modal)
				) {
					return false
				}

				const inputValuesForRow =
					inputValues[`${currentRecord.key}${service.itemCode}`] || []
				const inputParametrQuantityValues =
					inputParametrQuantity[
						`${currentRecord.key}${service.itemCode}`
					] || []

				// Check if quantity comes from any source
				const hasDirectQuantity = service.quantity > 0
				const hasShapeInputs =
					inputValuesForRow.length > 0 &&
					inputValuesForRow.some(
						(val) => parseFloat(val || 0) > 0,
					)
				const hasParametrQuantity =
					inputParametrQuantityValues.length > 0 &&
					inputParametrQuantityValues.some(
						(val) => parseFloat(val || 0) > 0,
					)

				// Service is invalid if it has no inputs from any source
				return !(
					hasDirectQuantity ||
					hasShapeInputs ||
					hasParametrQuantity
				)
			},
		)

		if (servicesWithoutQuantity.length > 0) {
			console.log('servicesWithoutQuantity', servicesWithoutQuantity)
			const invalidServices = servicesWithoutQuantity
				.map((s) => s.itemName)
				.join(', ')
			message.error(
				`Пожалуйста, заполните количество для: ${invalidServices}`,
			)
			return
		}

		// Calculate selectedPrices and shtPrices for services
		const selectedPrices = calculateKvmPrices(updatedSelectedServices)

		const shtPrices = calculateShtPrices(updatedSelectedServices)

		//
		const totalPerimetr = updatedSelectedServices.reduce((acc, service) => {
			return acc + service.totalPemitr
		}, 0)

		const updatedData = tableData.map((row) => {
			if (row.key === currentRecord.key) {
				const koef = 1
				const totalWithKoef = calculateTotalWithKoef(
					row.width,
					row.height,
					row.quantity,
					koef,
				)
				const mWithKoef = calculateMetrTotalWithKoef(
					row.width,
					row.height,
					row.quantity,
					koef,
				)

				const mPrices = updatedSelectedServices.reduce(
					(acc, service) => {
						if (service.ugpName === 'м') {
							return acc + service.price * mWithKoef
						}
						return acc
					},
					0,
				)

				const lineTotal =
					calculateLineTotal(
						row.price,
						selectedPrices,
						totalWithKoef,
					) +
					mPrices +
					shtPrices

				return {
					...row,
					selectedServices: updatedSelectedServices,
					lineTotal,
					totalPerimetr,
				}
			}
			return row
		})

		setTableData(updatedData)
		setSelectedServices(updatedSelectedServices)
		setIsModalOpen(false)
	}

	const summarizeTableData = (data) => {
		const groupedData = data.reduce((acc, record) => {
			const {
				itemName,
				width,
				height,
				quantity,
				koefitsent,
				amountInWhs,
				price,
			} = record
			const koef = koefitsent || 1
			const totalWithKoef = calculateTotalWithKoef(
				width,
				height,
				quantity,
				1,
			)

			if (!acc[itemName]) {
				acc[itemName] = {
					...record,
					lineTotalWithKoef: 0,
					lineTotal: 0,
					count: 0,
					amountInWhs,
					koefitsent,
				}
			}

			acc[itemName].lineTotalWithKoef += totalWithKoef
			acc[itemName].count += 1

			return acc
		}, {})

		return Object.values(groupedData).map((item, index) => ({
			...item,
			key: index,
		}))
	}

	const summarizedData = summarizeTableData(tableData)

	const totalPerimetrToM = tableData.reduce(
		(acc, curr) => {
			acc.height += curr.height / 1000
			acc.width += curr.width / 1000
			acc.quantity += curr.quantity
			return acc
		},
		{ height: 0, width: 0, quantity: 0 },
	)

	return (
		<Layout>
			<div className={'p-7'}>
				<div className="flex items-center gap-10 flex-wrap">
					<div className={'flex items-end'}>
						<div className="flex flex-col items-start gap-3 ">
							<p className="font-nunito">{t('Client')}</p>
							<AutoComplete
								loading={loadingClient}
								showSearch
								value={clientName}
								className=" w-[300px]"
								onSelect={(value) => {
									const val = value.split(' ,/ ')[0]

									setClientName(val)
									handleCardNameChange(val)
									const selectedOption = clientsData.find(
										(client) => {
											const cardName = get(
												client,
												'cardName',
												'',
											)
											const cardCode = get(
												client,
												'cardCode',
												'',
											)
											const phoneNumber = get(
												client,
												'Cellular',
												'',
											)
												? get(client, 'Cellular', '')
												: ''
											const formattedValue = [
												cardName,
												phoneNumber,
											]
												.filter(Boolean)
												.join(' ')
											return (
												`${formattedValue} ,/ ${cardCode}` ===
												value
											)
										},
									)

									if (selectedOption) {
										const cardCode = get(
											selectedOption,
											'cardCode',
											'',
										)
										setClientCode(cardCode)
									}
								}}
								onChange={(val) => {
									const value = val.split(' ,/ ')[0]
									setClientName(value)
									handleCardNameChange(value)
								}}
								options={clientsData.map((client) => ({
									value: `${client.cardName}${client.Cellular ? ` ${client.Cellular}` : ''} ,/ ${client.cardCode}`,
									label: (
										<div className="flex items-center justify-between">
											<p>{client.cardName}</p>
											{client.Cellular && (
												<Tag
													color="blue"
													className="text-[9px]"
												>
													{client.Cellular}
												</Tag>
											)}
										</div>
									),
								}))}
							/>
						</div>
						<button
							className="w-[30px] h-8 bg-blue-700 text-white text-lg hover:bg-blue-500"
							onClick={() => setIsModalVisible(true)}
						>
							+
						</button>
					</div>
					<div className="flex flex-col gap-2">
						<p>{t('currency')}</p>
						<div className="flex">
							<Select
								value={currency}
								onChange={(value) => setCurrency(value)}
								className="w-[150px]"
								disabled
							>
								<Select.Option key={1} value={'UZS'}>
									UZS
								</Select.Option>
								<Select.Option key={1} value={'USD'}>
									USD
								</Select.Option>
							</Select>
						</div>
					</div>
					{roleNames.includes('admin') && (
						<div className="flex flex-col gap-2">
							<p>{t('departmentName')}</p>
							<div className="flex">
								<Select
									value={departmentAdmin}
									className="flex h-8  w-[150px] items-center justify-center "
									style={{ color: 'black' }}
									onChange={(val) => {
										setDepartmentAdmin(val)
									}}
									loading={departmentLoading}
									options={departmentData.map(
										(department) => {
											return {
												label: department.name,
												value: Number(department.code),
											}
										},
									)}
									filterOption={(input, option) =>
										option.label
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									showSearch
								/>
							</div>
						</div>
					)}
					{roleNames.includes('admin') && (
						<div className="flex flex-col gap-2">
							<p>{t('slpName')}</p>
							<Select
								value={slpCode}
								className="flex h-8  w-[150px] items-center justify-center "
								style={{ color: 'black' }}
								onChange={(val) => {
									setSlpAdmin(val)
								}}
								loading={slpLoading}
								options={slpData.map((slp) => {
									return {
										label: slp.slpName,
										value: Number(slp.slpCode),
									}
								})}
								filterOption={(input, option) =>
									option.label
										.toLowerCase()
										.includes(input.toLowerCase())
								}
								showSearch
							/>
						</div>
					)}
					{roleNames.includes('admin') && (
						<div className="flex flex-col gap-2">
							<p>{t('date')}</p>
							<Input
								type="date"
								value={dateSale}
								onChange={(e) => setDateSale(e.target.value)}
								className="w-full"
							/>
						</div>
					)}
					{roleNames.includes('admin') && (
						<div className="flex flex-col gap-2">
							<p>{t('whs')}</p>
							{/* <Spin spinning={whsLoading}> */}
							<Select
								value={whs}
								onChange={(value) => setWhs(value)}
								className="w-[200px] "
								loading={whsLoading}
								options={warehouseData.map((warehouse) => ({
									label: warehouse.name,
									value: warehouse.code,
								}))}
								filterOption={(input, option) =>
									option.label
										.toLowerCase()
										.includes(input.toLowerCase())
								}
								showSearch
							/>
							{/* </Spin> */}
						</div>
					)}
				</div>

				<div className="flex items-end gap-2 mt-5 ">
					<div className="flex flex-col gap-2">
						<p>{t('bpDebt')}</p>
						<Input
							value={
								clientCode
									? `${numberWithSpacesIntl(bpDebt) || 0} USD`
									: ''
							}
							className="w-[200px] "
							disabled
						/>
					</div>
					<Button
						type="primary"
						onClick={() => setIsViewBpBalanceModalVisible(true)}
						disabled={!clientCode}
						className="bg-blue-700 text-white rounded-lg  hover:bg-blue-500 disabled:bg-blue-300"
					>
						<ViewIcon />
					</Button>
				</div>

				<Table
					columns={columns}
					dataSource={tableData}
					pagination={false}
					className="border-1 mt-12 border-black  my-custom-table"
					bordered
					scroll={{ x: 'max-content' }}
				/>

				<Table
					columns={columnsKoefitsent}
					dataSource={summarizedData}
					pagination={false}
					className="border-1 mt-2 border-black"
					bordered
					scroll={{ x: 'max-content' }}
				/>

				<div className="flex gap-10 mt-20 drop-shadow-lg bg-white p-5 rounded-lg">
					<div className="w-full flex flex-col  gap-6 ">
						<div className="flex flex-col items-start gap-3 ">
							<p className="font-nunito">{t('deadLine')}</p>
							<Input
								type={'number'}
								onWheel={(e) => e.target.blur()}
								min={0}
								className={'w-full h-10'}
								onChange={handleDateChange}
							/>
						</div>
						<div className="flex   gap-5 items-end">
							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">{t('minTotal')}</p>
								<Input
									type="text"
									value={`${numberWithSpacesIntl(docTotal || 0)} ${currency}`}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>
							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">{t('totalKvm')}</p>
								<Input
									type="text"
									value={totalKvm}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>
							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">
									{t('totalPerimeter')} ({t('m')})
								</p>
								<Input
									type="text"
									value={formatNumberWithSpaces(
										(totalPerimetrToM.height +
											totalPerimetrToM.width) *
											2 *
											totalPerimetrToM.quantity,
									)}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>
						</div>
						{/* <div className="flex   gap-5 items-end">
							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">
									{t('arendaTotal')}
								</p>
								<Input
									type="text"
									value={formatNumberWithSpaces(
										arendaTotal?.total,
									)}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>
							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">
									{t('ishHaqiTotal')}
								</p>
								<Input
									type="text"
									value={formatNumberWithSpaces(
										ishHaqiTotal?.total,
									)}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>
							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">
									{t('elektrTotal')}
								</p>
								<Input
									type="text"
									value={formatNumberWithSpaces(
										elektrTotal?.total,
									)}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>
							<div className="flex flex-col items-start gap-3">
								<p className="font-nunito">
									{t('stanokTotal')}
								</p>
								<Input
									type="text"
									value={formatNumberWithSpaces(
										stanokTotal?.total,
									)}
									className="h-10 w-full "
									style={{ color: 'black' }}
									disabled
								/>
							</div>
						</div> */}
						<div className="flex flex-col items-start gap-3 ">
							<p className="font-nunito">{t('docTotal')}</p>
							<Input
								value={formatNumberWithSpaces(inputDocTotal)}
								className={'w-full h-10'}
								min={docTotal || 0}
								suffix={
									<span className="text-gray-400">UZS</span>
								}
								onBlur={handleDocTotalBlur}
								onChange={handleDocTotalChange}
							/>
							{isDiscountBigger && (
								<p className="text-red-600 font-nunito">
									{t('docTotalBigger')}{' '}
									{numberWithSpacesIntl(docTotal) || 0}
								</p>
							)}
						</div>

						{/* <div className="flex flex-col items-start gap-3 ">
							<p className="font-nunito">{t('Discount')}</p>
							<Input
								// type={'number'}
								controls={false}
								value={
									docTotalWithDiscount,
								}
								className={'w-full'}
								min={0}
								onChange={(e) => {
									const val = e.target.value
									if (
										val <=
										(docTotal / 100) *
											get(getMe, 'u_Discount', 1)
									) {
										setDocTotalWithDiscount(val)
										setIsDiscountBigger(false)
									} else {
										setIsDiscountBigger(true)
									}
								}}
							/>
							{isDiscountBigger && (
								<p className="text-red-600 font-nunito">
									{t('discountBigger')}{' '}
									{(docTotal / 100) *
										get(getMe, 'u_Discount', 1) || 0}
								</p>
							)}
						</div> */}
						<div className="flex flex-col items-start gap-3 w-full">
							<p className="font-nunito">{t('sendFile')}</p>
							<Input
								type="checkbox"
								value={sendFile}
								onChange={(e) => {
									setSendFile(e.target.checked)
								}}
								className="w-fit"
							/>
						</div>
					</div>

					<div className="w-full flex  h-full">
						<div className="flex flex-col items-start gap-3 w-full">
							<p className="font-nunito">{t('comments')} </p>
							<TextArea
								className={'w-full'}
								rows={11}
								onChange={(e) => {
									setComments(e.target.value)
								}}
							/>
						</div>
					</div>
				</div>
				<div>
					{imageList.map((image, index) => (
						<div
							key={index}
							className="flex w-full items-start gap-1 flex-col mt-5 mb-10"
						>
							<div>
								<p className="font-bold">
									{t('photo')}-{index + 1}
								</p>
							</div>
							<div className="flex items-center gap-3">
								<Input
									type="file"
									onChange={(e) => handleFileChange(e, index)}
									className="w-full"
								/>

								<Button
									onClick={() => uploadImg(index)}
									isLoading={image.imgLoading}
									className="h-9 w-[200px] rounded-3xl bg-[#0A4D68] text-white"
								>
									{t('upload')}
								</Button>
								{image.path && (
									<Button
										onClick={() => viewImage(index)}
										className="h-9 w-[200px] rounded-3xl bg-[#0A4D68] text-white"
									>
										{t('download')}
									</Button>
								)}
								{index !== 0 && (
									<Button
										onClick={() => deleteRow(index)}
										className="h-9 w-[70px] rounded-3xl  bg-red-500 text-white"
									>
										{/* {t("delete")} */}-
									</Button>
								)}

								{index === imageList.length - 1 && (
									<Button
										onClick={addNewRow}
										className="h-9 w-[70px] rounded-3xl bg-[#0A4D68] text-white"
									>
										{/* {t("add2")} */}+
									</Button>
								)}
							</div>
						</div>
					))}
				</div>

				<div className={'flex mt-10 w-full items-center gap-10'}>
					<Button
						onClick={() => setIsConfirmModalVisible(true)}
						type={'danger'}
						className="w-full bg-red-600 text-white"
					>
						{t('back')}
					</Button>
					<Button
						onClick={onSubmit}
						loading={btnLoading}
						disabled={
							btnLoading ||
							(imageList.every((image) => image.file) &&
								!imageList.every((image) => image.path))
							// !tableData.length === 0 ||
							// !clientCode ||
							// !departmentAdmin ||
							// !slpCode ||
							// !dateSale ||
							// !whs
						}
						type={'primary'}
						className="w-full"
					>
						{t('create')}
					</Button>
				</div>
			</div>

			<Modal
				title={
					<div className="flex items-center gap-2">
						<span className="cursor-pointer text-2xl font-bold">
							{t('services')}
						</span>
					</div>
				}
				open={isModalOpen}
				onCancel={() => {
					setIsConfirmServiceModalVisible(true)
				}}
				// onOk={handleOkServices}
				footer={null}
				width="65%"
			>
				<div className="w-full">
					<Space style={{ marginBottom: 16 }} className="mt-5 ovew">
						<button
							className={`${
								activeTab === 'tab1'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold `}
							onClick={() => setActiveTab('tab1')}
						>
							{t('Kalit Xizmatlari')}
						</button>
						<button
							className={`${
								activeTab === 'tab2'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab2')}
						>
							{t('Dumaloq Xizmatlari')}
						</button>
						<button
							className={`${
								activeTab === 'tab3'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab3')}
						>
							{t('Rombik Shakllari')}
						</button>
						<button
							className={`${
								activeTab === 'tab4'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab4')}
						>
							{t('Shablon Shakllari')}
						</button>
						<button
							className={`${
								activeTab === 'tab5'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab5')}
						>
							{t('Kalit Shakllari')}
						</button>
						<button
							className={`${
								activeTab === 'tab6'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab6')}
						>
							{t('Rombik Chizmalari')}
						</button>
						<button
							className={`${
								activeTab === 'tab7'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab7')}
						>
							{t('Kalit Chizmalari')}
						</button>
						<button
							className={`${
								activeTab === 'tab8'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab8')}
						>
							{t('Ortish(Отгрузка)')}
						</button>

						{/* <button
							className={`${
								activeTab === 'tab3'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3`}
							onClick={() => setActiveTab('tab3')}
						>
							{t('shapes')}
						</button>
						<button
							className={`${
								activeTab === 'tab4'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3`}
							onClick={() => setActiveTab('tab4')}
						>
							{t('chizmalar')}
						</button> */}
					</Space>
					<div className="mt-5">{renderContent()}</div>
					<div className="mt-5 flex items-center justify-end  gap-2">
						<Button
							type="danger"
							className="bg-red-600 text-white hover:bg-red-500"
							onClick={() => {
								setIsConfirmServiceModalVisible(true)
							}}
						>
							{t('cancel')}
						</Button>
						<Button
							type="danger"
							className="bg-blue-800 text-white hover:bg-blue-600"
							onClick={handleOkCombined}
						>
							{t('save')}
						</Button>
					</div>
				</div>
			</Modal>

			<CreteCustomerModal
				visible={isModalVisible}
				data={null}
				onClose={() => {
					refetch()
					setIsModalVisible(false)
				}}
				onConfirm={(code) => {
					const data = `${code?.name} ${code?.phoneNumber ? code?.phoneNumber : ''}`
					setClientName(data)
					setClientCode(code?.cardCode)
				}}
			/>
			<ViewDepartmentsBalanceModal
				visible={isViewBpBalanceModalVisible}
				data={bpBalanceData[0]}
				onClose={() => {
					setIsViewBpBalanceModalVisible(false)
				}}
			/>

			<ConfirmExitModal
				visible={isConfirmModalVisible}
				handleClickCancel={handleModalCancel}
				handleClickNo={handleModalNo}
				handleClickYes={handleModalYes}
			/>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
				onConfirm={() => {
					navigate('/sales-order')
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<WarningModal
				getRef={(r) => {
					warningRef.current = r
				}}
			/>
			<ConfirmExitModal
				visible={isConfirmServiceModalVisible}
				handleClickCancel={handleServiceModalCancel}
				handleClickNo={handleServiceModalNo}
				handleClickYes={handleServiceModalYes}
			/>
		</Layout>
	)
}

export default CreateSales
